(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (!customElements.get('rv-search-page')) {
    customElements.define('rv-search-page', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const sort = this.querySelector('[data-rvsp-sort]');
        const edit = this.querySelector('[data-rvsp-edit]');
        const headerInputs = () => Array.from(document.querySelectorAll('.section-header input[type="search"][name="q"]'));
        const syncHeader = () => {
          const inputs = headerInputs();
          // La consulta permanece en el buscador fijo, sin abrir sugerencias al cargar.
          inputs.forEach(input => {
            if (!input.value && document.activeElement !== input) {
              input.value = this.dataset.searchTerms || '';
              input.closest('predictive-search')?.updateClearButton?.();
            }
          });
          edit.hidden = !inputs.length;
        };
        syncHeader();
        document.addEventListener('shopify:section:load', syncHeader, options);
        edit.addEventListener('click', () => {
          const input = headerInputs().find(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && !element.disabled);
          if (!input) return;
          input.focus();
          input.setSelectionRange(input.value.length, input.value.length);
        }, options);
        sort?.addEventListener('change', () => {
          // Shopify ordena todos los resultados; conserva la consulta y los filtros de la URL.
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          url.hash = '';
          window.location.assign(url.href);
        }, options);
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-aviso-cerrable"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rv-dismissible-notice')) {
    customElements.define('rv-dismissible-notice', class extends HTMLElement {
      connectedCallback() {
        if (this.onClose) return;
        this.button = this.querySelector('.rv-notice__close');
        if (!this.button) return;
        this.wrapper = this.closest('.shopify-section') || this;
        this.designMode = this.dataset.designMode === 'true';
        this.key = 'rv-notice:' + this.dataset.sectionId;
        this.message = this.dataset.message;
        this.wrapper.hidden = false;
        if (!this.designMode && this.dataset.remember === 'true') {
          try {
            this.wrapper.hidden = sessionStorage.getItem(this.key) === this.message;
          } catch (_) {}
        }
        this.onClose = () => {
          if (!this.designMode && this.dataset.remember === 'true') {
            try { sessionStorage.setItem(this.key, this.message); } catch (_) {}
          }
          this.wrapper.hidden = true;
        };
        this.button.addEventListener('click', this.onClose);
        this.button.hidden = false;
        if (this.designMode) {
          this.onSelect = event => {
            if (event.detail && event.detail.sectionId === this.dataset.sectionId) {
              this.wrapper.hidden = false;
            }
          };
          document.addEventListener('shopify:section:select', this.onSelect);
        }
      }
      disconnectedCallback() {
        if (this.button && this.onClose) this.button.removeEventListener('click', this.onClose);
        if (this.onSelect) document.removeEventListener('shopify:section:select', this.onSelect);
        this.onClose = null;
        this.onSelect = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-categorias"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rv-categorias')) {
    customElements.define('rv-categorias', class extends HTMLElement {
      connectedCallback() {
        if (this.rvController || this.rvFrame) return;
        this.rvFrame = requestAnimationFrame(() => {
          this.rvFrame = null;
          if (this.isConnected) this.initialize();
        });
      }

      initialize() {
        const input = this.querySelector('.rv-cats__input');
        if (!input || this.rvController) return;
        const count = this.querySelector('.rv-cats__count');
        const empty = this.querySelector('.rv-cats__empty');
        const reset = this.querySelector('.rv-cats__reset');
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es').replace(/\s+/g, ' ').trim();
        const items = Array.from(this.querySelectorAll('.rv-cats__item'), element => ({
          element,
          name: normalize(element.querySelector('.rv-cats__name').textContent)
        }));
        this.rvController = new AbortController();
        const options = { signal: this.rvController.signal };
        const filter = () => {
          const query = normalize(input.value);
          this.toggleAttribute('data-rv-searching', query.length > 0);
          let matches = 0;
          items.forEach(item => {
            const visible = item.name.includes(query);
            item.element.hidden = !visible;
            if (visible) matches += 1;
          });
          count.textContent = matches + (matches === 1 ? ' categoría' : ' categorías');
          empty.hidden = matches > 0;
        };
        input.addEventListener('input', filter, options);
        reset.addEventListener('click', () => {
          input.value = '';
          filter();
          input.focus();
        }, options);
        filter();
      }

      disconnectedCallback() {
        if (this.rvFrame) cancelAnimationFrame(this.rvFrame);
        this.rvFrame = null;
        if (this.rvController) this.rvController.abort();
        this.rvController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-laboratorios"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rv-laboratorios')) {
    customElements.define('rv-laboratorios', class extends HTMLElement {
      connectedCallback() {
        if (this.rvController || this.rvFrame) return;
        this.rvFrame = requestAnimationFrame(() => {
          this.rvFrame = null;
          if (this.isConnected) this.initialize();
        });
      }

      initialize() {
        if (this.rvController) return;
        const input = this.querySelector('.rv-labs__input');
        if (!input) return;

        const empty = this.querySelector('.rv-labs__empty');
        const reset = this.querySelector('.rv-labs__reset');
        const status = this.querySelector('.rv-labs__status');
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es').replace(/\s+/g, ' ').trim();
        const items = Array.from(this.querySelectorAll('.rv-labs__item'), element => ({
          element,
          name: normalize(element.querySelector('.rv-labs__name').textContent)
        }));
        // Usa las colecciones del menú para conservar la navegación activa de Minion.
        if (this.dataset.rvDirectory) {
          const menuLink = Array.from(document.querySelectorAll('header[data-role="main"] a[href]')).find(link =>
            link.pathname === this.dataset.rvDirectory && link.closest('.submenu-container, .menu-drawer__submenu')
          );
          const branch = menuLink && menuLink.closest('.submenu-container, .menu-drawer__submenu');
          if (branch) {
            const key = value => normalize(value).replace(/[^a-z0-9]/g, '');
            const destinations = new Map();
            branch.querySelectorAll('a[href]').forEach(link => {
              const collectionPath = link.pathname.match(/\/collections\/([^/]+)\/?$/);
              if (!collectionPath || link.origin !== location.origin) return;
              const href = link.getAttribute('href');
              destinations.set(key(link.textContent), href);
              destinations.set(key(collectionPath[1]), href);
            });
            items.forEach(item => {
              const href = destinations.get(key(item.name));
              if (href) item.element.querySelector('.rv-labs__link').setAttribute('href', href);
            });
          }
        }
        this.rvController = new AbortController();
        const options = { signal: this.rvController.signal };

        const filter = () => {
          const query = normalize(input.value);
          this.toggleAttribute('data-rv-searching', query.length > 0);
          let count = 0;
          items.forEach(item => {
            const visible = item.name.includes(query);
            item.element.hidden = !visible;
            if (visible) count += 1;
          });
          empty.hidden = count > 0;
          status.textContent = count === 1 ? '1 laboratorio encontrado.' : count + ' laboratorios encontrados.';
        };

        input.addEventListener('input', filter, options);
        input.addEventListener('keydown', event => {
          if (event.key !== 'Enter' || event.isComposing) return;
          event.preventDefault();
          filter();
          input.blur();
        }, options);
        reset.addEventListener('click', () => {
          input.value = '';
          filter();
          input.focus();
        }, options);
        filter();
      }

      disconnectedCallback() {
        if (this.rvFrame) cancelAnimationFrame(this.rvFrame);
        this.rvFrame = null;
        if (this.rvController) this.rvController.abort();
        this.rvController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
